export const INVOICE_STATUSES = Object.freeze({
    new: 'new',
    autoSuccess: 'autosuccess',
    autoFailed: 'autofailed',
    manualSuccess: 'manualsuccess',
    pending: 'pending',
    rejected: 'rejected',
    generalError: 'generalerror',
    manualFailedDisputed: 'manualfailed-disputed'
})
export const INVOICE_STATUS_TEXT = Object.freeze({
    success: 'Payment received',
    pending: 'Pending reconciliation from Edenred',
    reject: 'Rejected'
})

export const INVOICE_LEFT_INFO_SECTION = Object.freeze({
    viewAllInvoices: 'View All Invoices',
    statementOfAccounts: 'Statement of Accounts',
    paymentHistory: 'Payment History',
    timeSaverCard: {
        label: 'Time Saving Tip',
        description: 'Pay by Bank Transfer for automatic reconciliation'

    }
})